/** Map ops API error payloads ({ code, message }) to i18n. */

export function opsErrorMessage(err, t, fallbackKey) {
  const detail = err?.response?.data?.detail
  const code = detail && typeof detail === "object" ? detail.code : null
  if (code) {
    const translated = t(`app.ops.errors.${code}`, { defaultValue: "" })
    if (translated) return translated
    if (typeof detail.message === "string" && detail.message) return detail.message
  }
  if (typeof detail === "string") return detail
  if (detail && typeof detail.message === "string") return detail.message
  return t(fallbackKey)
}
